import React from "react";

export const ALL_COMPETITIONS = "all";

// Chip order — lead with our highest-value leagues so Premier League is always the
// first (and on mobile, the only visible) league chip. Anything not listed falls
// back to A–Z after these. Sorting lives here so every consumer of the filter
// (dashboard fixtures, team list, freemium teaser) orders leagues identically.
export const COMPETITION_PRIORITY = ["Premier League", "La Liga", "Major League Soccer"];

export const sortCompetitions = (competitions = []) => {
    const rank = (name) => {
        const i = COMPETITION_PRIORITY.indexOf(name);
        return i === -1 ? COMPETITION_PRIORITY.length : i;
    };
    return [...competitions].sort((a, b) =>
        rank(a.season_name) - rank(b.season_name) ||
        (a.season_name || "").localeCompare(b.season_name || "")
    );
};

// `showAll` opts out of the leading "All" chip, for places that always want exactly
// one league selected (e.g. the landing hero, where the cards below are per-league).
const CompetitionFilter = ({ competitions, value, onChange, showAll = true }) => {
    const options = [
        ...(showAll && competitions.length > 1 ? [{ id: ALL_COMPETITIONS, label: "All" }] : []),
        ...sortCompetitions(competitions).map((comp) => ({ id: String(comp.id), label: comp.season_name })),
    ];

    return (
        <div
            id="competition-filter"
            className="d-flex column-gap-2 overflow-x-auto flex-nowrap pb-2"
            style={{ WebkitOverflowScrolling: "touch" }}
        >
            {options.map((option) => {
                const isActive = String(value) === option.id;
                return (
                    <button
                        key={option.id}
                        type="button"
                        onClick={() => onChange(option.id)}
                        className={`border rounded-2 px-3 py-2 small flex-shrink-0 text-nowrap ${isActive
                            ? "bg-dark-mode-500 border-mint-green-900 text-white fw-semi-bold"
                            : "bg-transparent border-dark-mode-700 text-neutral-gray-700 fw-normal"
                            }`}
                    >
                        {option.label}
                    </button>
                );
            })}
        </div>
    );
};

export default CompetitionFilter;
